import React, { useEffect, useState } from "react";
import {
  Input,
  Box,
  Button,
  Spacer,
  Text,
  Checkbox,
} from "@flexisaf/flexibull2";
import { useForm } from "react-hook-form";
import LoginLayout from "../../components/LoginLayout";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { useNavigate, useSearchParams } from "react-router-dom";
import usePasswordRecovery from "../../hooks/password-recovery/usePasswordRecovery";
import PasswordValidation from "../../components/custom/password-validation";
import { INSTITUTION_ID } from "../../utils/constants";
import Theme from "../../theme";

const getDefaultPasswordResetInformation = () => ({
  password: "",
  confirmPassword: "",
});

const ResetPassword = () => {
  const { resetPassword, isLoadingPasswordRecovery } = usePasswordRecovery();
  const [showPassword, setShowPassword] = useState(false);
  const [successInfo, setSuccessInfo] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const userId = searchParams.get("user");
  const navigate = useNavigate();

  const {
    register,
    watch,
    formState: { errors },
    handleSubmit,
    setValue,
    getValues,
  } = useForm({
    defaultValues: {
      ...getDefaultPasswordResetInformation(),
    },
  });

  const handleResetPassword = (v) => {
    const payload = {
      data: {
        password: v.password,
        token: token || "",
        userId: userId || "",
        institutionId: INSTITUTION_ID,
      },

      callback: () => {
        setSuccessInfo(true);
      },
    };
    resetPassword(payload);
  };

  useEffect(() => {
    if (!userId || !token) {
      navigate("/login");
    }
  }, [navigate, token, userId]);

  return (
    <LoginLayout>
      <Box pad="32px">
        {!successInfo && (
          <>
            <Box pad="24px" align="center">
              <Text block capitalize size="1.8rem">
                Reset Password
              </Text>
              <Spacer height={12} />
              <Text>You're one step away from recovering your account</Text>
            </Box>
            <PasswordValidation
              watch={watch}
              register={register}
              getValues={getValues}
              setValue={setValue}
              fieldErrors={errors}
              showPassword={showPassword}
              field="password"
              type="password"
              label="New Password"
              placeholder="Password"
            />
            <Spacer space="20px" />
            <Input
              type={showPassword ? "text" : "password"}
              required
              spaceTop
              style={{ backgroundColor: "#F7F7FF" }}
              block
              label="Confirm New Password"
              placeholder="Confirm Password"
              value={watch("confirmPassword")}
              {...register("confirmPassword", {
                required: "Password is required",
                validate: (val) => {
                  if (watch("password") !== val) {
                    return "Passwords do not match";
                  }
                },
              })}
              error={errors.confirmPassword?.message}
              onChange={({ target: { value } }) =>
                setValue("confirmPassword", value)
              }
            />
            <Spacer space="5px" />
            <Box>
              <Checkbox
                label="Show Password"
                onChange={(e) => setShowPassword(e.target.checked)}
                checked={showPassword}
              />
            </Box>
            <Spacer space="16px" />
            <Button
              block
              progress={isLoadingPasswordRecovery}
              onClick={handleSubmit((v) => handleResetPassword(v))}
            >
              Change Password
            </Button>
            <Spacer space="16px" />
            <Button pale block onClick={() => navigate("/forgot-password")}>
              Resend link
            </Button>
          </>
        )}
        {successInfo && (
          <Box>
            <Box align="center">
              <RiCheckboxCircleLine size="1.5rem" color={Theme.PrimaryColor} />
              <Text block size="1.5rem">
                Password Changed
              </Text>
              <Spacer space="10px" />
              <Text block>
                Your password has been changed successfully, you can now login
                to your account with your updated password.
              </Text>
            </Box>
            <Spacer space="16px" />
            <Button block onClick={() => navigate("/login")}>
              Proceed to login
            </Button>
          </Box>
        )}
      </Box>
    </LoginLayout>
  );
};

export default ResetPassword;
